import type { Impersonation } from '@/api/types'
import { useSession } from '@/lib/access'

function endsAt(iso: string): string {
  const moment = new Date(iso)
  if (Number.isNaN(moment.getTime())) return iso
  return new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' }).format(moment)
}

/**
 * The words the banner says. Separate from the component so the sentence the
 * tenant reads is testable without rendering the shell.
 */
export function impersonationNotice(impersonation: Impersonation): string {
  const mode = impersonation.elevated ? 'elevated' : 'read-only'
  return `TmT Support is viewing this organisation as ${impersonation.actor} — ${mode} — ends at ${endsAt(impersonation.expiresAt)}`
}

/**
 * Shown on every page while TmT support is inside this tenant (blueprint 03
 * §3.9): who, why, whether they can write, and when it ends. It has no close
 * button on purpose — there is no hidden mode, so there is nothing to hide it
 * with. It renders nothing only when the session says it is not an
 * impersonation.
 */
export function ImpersonationBanner() {
  const session = useSession()
  const impersonation = session.data?.impersonation
  if (!impersonation) return null
  return (
    <div
      className="ci-banner"
      role="status"
      aria-label="Support impersonation"
      data-impersonation={impersonation.elevated ? 'elevated' : 'read-only'}
    >
      <strong>{impersonationNotice(impersonation)}</strong>
      <span>Reason: {impersonation.reason}</span>
    </div>
  )
}
